package org.example.project.dashboard

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
internal fun MobileDashboardBackground() {
    Div({
        attr("aria-hidden", "true")
        style {
            position(Position.Absolute)
            property("inset", "0")
            property("background", DashboardTheme.DASHBOARD_BG)
            property("pointer-events", "none")
            property("z-index", "0")
        }
    })
}

internal const val mobileDashboardIconSurface =
    "transparent"

internal const val mobileDashboardCardSurface =
    "linear-gradient(90deg, rgba(54,60,70,0.84) 0%, rgba(45,50,59,0.90) 36%, rgba(37,42,50,0.95) 46%, rgba(27,31,38,0.98) 100%)"
